import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'

const Navbar = () => {
    const navigate = useNavigate();
    const { currentUser, UserSignOut } = useAuth();

    const handleLogIn = () => {
        navigate("/sign-in");
    }

    const handleLogOut = async () => {
        try {
          await UserSignOut();
          navigate("/sign-in");
        }
        catch (error) {
          console.log(error.message);
        }
      };    

    return (
        <nav className="w-full">
            <div className="flex justify-end p-4 gap-4">
                {
                    currentUser ?
                        // show Log Out button
                        <button
                            className="bg-main-purple hover:bg-primary-300 p-4 rounded-lg font-medium text-lg text-white"
                            onClick={() => handleLogOut()}>
                            Log Out
                        </button>
                        :
                        // show Log In button
                        <button
                            className="bg-main-purple hover:bg-primary-300 p-4 rounded-lg font-medium text-lg text-white"
                            onClick={() => handleLogIn()}>
                            Log In
                        </button>
                }
            </div>
        </nav>
    )
}

export default Navbar
